const styles = {
  wrapper: 'content-box overflow-hidden',
};

export default styles;
